import clsx from 'clsx';
import { motion, MotionProps } from 'framer-motion';
import { ComponentPropsWithoutRef, FC } from 'react';

interface ClickMenuContainerProps extends Pick<ComponentPropsWithoutRef<'ul'>, 'className'> {
  children?: React.ReactNode;
  motionProps?: MotionProps;
}

export const ClickMenuContainer: FC<ClickMenuContainerProps> = ({ children, className, motionProps }) => {
  return (
    <motion.ul
      className={clsx(
        'dark:shadow-classic shadow-lightModeClassic w-auto overflow-hidden rounded-2xl bg-darkMode-gray-floatingMenu py-2',
        className
      )}
      {...motionProps}
    >
      {children}
    </motion.ul>
  );
};
